import { DeskHeader, Sider } from "@desk/components";
import { cx } from "@emotion/css";
import type { RefineThemedLayoutV2Props } from "@refinedev/antd";
import { ThemedLayoutContextProvider } from "@refinedev/antd";
import { useInvalidate, useOne } from "@refinedev/core";
import { useIsFetching } from "@tanstack/react-query";
import { Button, Grid, Layout as AntdLayout, Typography } from "antd";
import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LongText } from "ui/preview";
// import { useSearchParam } from "react-use";
import type { Property } from "utils/types/object.type";

import { useGlobalStore } from "@/store";

const { Text } = Typography;
export const GlobalLayout: React.FC<RefineThemedLayoutV2Props> = ({
  children,
  Title,
  Footer,
  OffLayoutArea,
  initialSiderCollapsed,
}) => {
  const breakpoint = Grid.useBreakpoint();
  const isSmall = typeof breakpoint.sm === "undefined" ? true : breakpoint.sm;
  const { pathname } = useLocation();
  // const passedId = useSearchParam("property_id");
  const [searchParams] = useSearchParams();
  const passedId = searchParams.get("property_id");

  const navigate = useNavigate();
  const { propertyId, setPropertyId, setPropertyQueryData } = useGlobalStore();

  const isFetching = useIsFetching();
  const invalidate = useInvalidate();
  const { data: query, isLoading } = useOne<Property>({
    resource: "properties",
    id: propertyId,
    queryOptions: { enabled: !!propertyId },
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!passedId && propertyId) {
      const search = new URLSearchParams({ property_id: propertyId });
      // history.replaceState({}, "", `?${search}`);
      navigate(`?${search}`, { replace: true });
    }
    if (passedId) {
      if (passedId !== propertyId) {
        setPropertyId(passedId);
      }
    } else if (!propertyId && !passedId) {
      navigate("/select");
    }
  }, [propertyId, passedId, pathname]);

  useEffect(() => {
    setPropertyQueryData(query);
  }, [isLoading]);

  const refresh = () => {
    // queryClient.refetchQueries({ type: "active" });
    invalidate({ invalidates: ["all"] });
  };
  return (
    <ThemedLayoutContextProvider initialSiderCollapsed={initialSiderCollapsed}>
      <AntdLayout className="!h-screen" hasSider>
        <Sider
          icon={<img className="object-contain" src={LOGO_BASE_64} />}
          key={propertyId}
          onRefresh={refresh}
          refreshState={!!isFetching}
          Title={Title}
        >
          <div className="flex w-max items-center gap-4">
            <Text className="flex items-center text-white">
              <LongText maxFontSize={24} text={query?.data?.name ?? ""} />
            </Text>
            <Button onClick={() => navigate("/select")}>物件を切替</Button>
          </div>
        </Sider>
        <AntdLayout.Content>
          <DeskHeader />
          <AntdLayout.Content className="h-[calc(100vh-64px)] !overflow-scroll">
            <div className={cx("h-full", isSmall ? "p-6" : "p-3")}>{children}</div>
            {OffLayoutArea && <OffLayoutArea />}
          </AntdLayout.Content>
          {Footer && <Footer />}
        </AntdLayout.Content>
      </AntdLayout>
    </ThemedLayoutContextProvider>
  );
};

const LOGO_BASE_64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEbSURBVHgBrZS9SgNBFEbPnWxiBCOYJoIIsdIXsFesfBoL7QQrayEvYOEL+AgpRFLZaJvCRitRxEh2TXY/b+IPCgpJdg8sO3zMHOYyd8biTPcGS8yAr3sRXGTG/rzZ7Th7y9T2cIt8PA4GbC/M2XWQsefBM/moV8q0+Ng1JNIG4syHm5MaJFoZDErGwWc0THosh9GoAq9mdLz0h0mFFogj6P6IonKNmvWlZhBtD5rkxA9nLYSM4yJkXwQvdZcC8WqpUyCBgokmmDP09rgycemtchOV6PZi7qpVTEMa3jYrfhjr/t8Zz04y6Z/vKUl12JMaTMNfon6qI0k1ZuGXTOq4aJU8fMtSnbpskbyMZHGqE4rC38NzimR0lymQd4Neq1o+uws2AAAAAElFTkSuQmCC";
